import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {deliveriesFeatureKey, deliveriesReducer} from './deliveries.reducer';
import {EffectsModule} from '@ngrx/effects';
import {DeliveriesEffects} from './deliveries.effects';
import {StoreModule} from '@ngrx/store';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(deliveriesFeatureKey, deliveriesReducer),
    EffectsModule.forFeature([DeliveriesEffects])
  ]
})
export class DeliveriesStoreModule {

}
